import { useEffect, useRef } from 'react';

type ScrollIntoViewContainerProps = {
  valueToWatch?: any;
  testId?: string;
  sx?: any;
  children?: React.ReactNode;
};

export default function ScrollIntoViewContainer({
  valueToWatch,
  testId,
  sx = { width: '100%' },
  children,
}: Readonly<ScrollIntoViewContainerProps>) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (valueToWatch && containerRef.current) {
      containerRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [valueToWatch]);

  return (
    <div ref={containerRef} id={testId} style={sx}>
      {children}
    </div>
  );
}
